import { axiosInstance } from '@/shared/api/axios';
import {
  CustomerInfoByExecutionHistoryRequestType,
  CustomerInfoByExecutionHistoryResponseType,
} from '@/shared/types/api/api.customerInfo';

export const getCustomerInfoByExecutionHistory = async ({
  executionHistoryId,
}: CustomerInfoByExecutionHistoryRequestType): Promise<CustomerInfoByExecutionHistoryResponseType> => {
  const { data } = await axiosInstance.get<CustomerInfoByExecutionHistoryResponseType>(
    `/touki/customers/by-execution-history/${executionHistoryId}`,
  );

  return data;
};
